import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import App from './App';

// Monitor INP to identify slow interactions
if (typeof window !== 'undefined' && 'PerformanceObserver' in window) {
  try {
    new PerformanceObserver((entryList) => {
      for (const entry of entryList.getEntries()) {
        if (entry.duration > 200) {
          // Cast to any to resolve TypeScript error since PerformanceEventTiming is not fully typed
          const eventEntry = entry as any;
          console.warn('Slow interaction detected:', {
            type: entry.name,
            target: eventEntry.target?.nodeName || 'unknown',
            duration: `${entry.duration.toFixed(1)}ms`,
            startTime: entry.startTime,
          });
        }
      }
    // Cast to any to handle new properties not yet in TypeScript definitions
    }).observe({ type: 'event', buffered: true, durationThreshold: 200 } as any);
    
    console.info('INP monitoring enabled');
  } catch (e) {
    console.error('INP monitoring failed:', e);
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
